// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {2242: "113a03e268fa557a",5001: "83260e86592371df",7637: "4964038bf38035f5",8737: "cdd296530d066847",}[chunkId] + ".css"
}